import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Compra Inteligente',
  desc: 'Haz la compra inteligente usando nuestra lista de 10 imprescindibles.'
}, {
  num: '2',
  title: 'Elige tu Combinación',
  desc: 'Elige una de las 21 combinaciones según tu nivel de energía del día.'
}, {
  num: '3',
  title: 'Ensambla y Sirve',
  desc: 'Aplica la Regla de los 3 Bloques y sirve la cena en 15 minutos o menos.'
}];
export function HowItWorks() {
  return <section className="py-24 px-4 bg-brand-dark text-white" data-id="element-101">
      <div className="max-w-5xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-103">
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-104">Así de Simple Funciona</h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-105">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-stone-700 z-0" data-id="element-106"></div>

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-107">
              <div className="w-24 h-24 bg-brand-accent rounded-full flex items-center justify-center text-4xl font-serif font-bold text-white mb-6 shadow-[0_0_30px_rgba(234,88,12,0.3)] border-4 border-brand-dark" data-id="element-108">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold mb-4 font-sans" data-id="element-109">
                {step.title}
              </h3>
              <p className="text-stone-400 leading-relaxed max-w-xs" data-id="element-110">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}